import {Component, EventEmitter, Output} from '@angular/core';

import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'surveym-reasons-list',
  templateUrl: './reasons-list.component.html'
})
export class ReasonsListComponent {

  @Output() selectedReasonsChanged = new EventEmitter<string>();

  reasons: string[] = [];
  selectedReasons: number[] = [];

  constructor(
    private translateService: TranslateService
  ) {
    this.setReasons();
  }

  private setReasons() {
    //zwracany jest obiekt mając zweiracjący pola o nazwach kluczy do przetłumaczenia a ich wartość to przetłumaczony string
    this.translateService.get([
      'survey.reason-freezes',
      'survey.reason-device',
      'survey.reason-fuel',
      'survey.reason-bad-day']).subscribe(t =>
        Object.entries<string>(t).forEach((x) => this.reasons.push(x[1])));
  }

  isReasonSelected(tagIndex: number): boolean {
    return this.selectedReasons.findIndex(x => x === tagIndex) > -1;
  }

  onReasonClick(index: number) {
    this.setSelectedReasons(index);
    this.selectedReasonsChanged.emit(this.getSelectedReasons());
  }

  private setSelectedReasons(index: number) {
    const matchedIndex = this.selectedReasons.findIndex(x => x === index);
    if (matchedIndex > -1)
      this.selectedReasons = this.selectedReasons.filter(x => x != index);
    else
      this.selectedReasons.push(index);
  }

  private getSelectedReasons(): string {
    let result = '';

    for (let index of this.selectedReasons) {
      result += `${this.reasons[index]}/`;
    }

    return result.length > 0 ? ' POWODY: ' + result : '';
  }

}
